import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "mobx-react";
import "xyui";
import "./utils/xyStorage";
import App from "./App";
// import store from "./store/allStores";
import { enableScrollFix } from "./utils/scrollFix";
import "./styles/index.scss";

// import registerServiceWorker from './registerServiceWorker';

enableScrollFix();

ReactDOM.render(
  <Provider store>
    <App />
  </Provider>,
  document.getElementById("xy-app-root")
);

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js